import React from 'react';
import AssetImages from '../constants/images';
import '../constants/AssetsCss';
import { Link } from 'react-router-dom';
import GetORPostAsync from '../constants/restservice';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import withRouter from '../constants/withRouter';

class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);
        this.onusernameChange = this.onusernameChange.bind(this);
        this.getPassword = this.getPassword.bind(this);
        this.handleKeypress = this.handleKeypress.bind(this);
        this.state = {
            username: "",
        };
    }
    handleKeypress(e) {
        if (e.key === "Enter") {
            this.getPassword();
        }
    };
    async getPassword() {
        if (!this.validate()) {
            return;
        }
        //let jsondata = '{ "username" : "'+this.state.username+'" }';
        let res = await GetORPostAsync("ForgotPassword.asp", "POST", JSON.stringify(this.state));
        if (res.status === "error") {
            toast(res.message);
            return;
        }
        toast(res.message);
        this.props.history.goBack();
    }
    onusernameChange(event) {
        this.setState({ username: event.target.value });
    }
    validate() {
        let isValid = false;
        if (!this.state.username) {
            toast("Enter valid username");
        }
        else {
            isValid = true;
        }
        return isValid;
    }
    render() {
        return (
            <div className="page-content login-div" style={{ height: '100vh', alignItems: 'center', flexDirection: 'row' }}>
                <div className="content-wrapper content-wrapper2" style={{ backgroundColor: "rgb(0 0 0 / 68%)", padding: 10 }}>
                    <div className="content d-flex justify-content-center align-items-center">
                        <div className="login-form">
                            <div className="card">
                                <div className="card-body  mb-4">
                                    <div className="text-center mb-3">
                                        <div className='card mb-0' style={{ backgroundColor: "#1b1b1b" }}>
                                            <div className="card-body">
                                                <img src={AssetImages.logo} alt="img" className="" style={{ maxWidth: "100px" }} />
                                            </div>
                                        </div>
                                        <div class="login-separater text-center mb-4"> <span>Forgot Password</span><hr /></div>

                                        <div className='pt-5'>
                                            <span className="d-block">Enter a email to start a recovery process.</span>

                                        </div>
                                    </div>
                                    <div className="form-group form-group-feedback form-group-feedback-left">
                                        <div className="input-container" style={{
                                            border: "1px solid #fff",
                                            borderRadius: 5,
                                            backgroundColor: "#1e1e1e"
                                        }}>
                                            <i className="las la-user inputicon"></i>
                                            <input style={{ border: 0 }} id="username" onKeyPress={this.handleKeypress} name="username" placeholder="User Name" type="text" className="form-control input-field" onChange={this.onusernameChange} value={this.username} />
                                        </div>
                                    </div>
                                    <div className="form-group d-flex align-items-center">
                                        <Link to="/register" className="ml-auto">Register if you don't have an account</Link>
                                    </div>
                                    <div className="form-group form-group-feedback form-group-feedback-left" style={{ visibility: "hidden", height: 0 }}>
                                        <select className="form-control " id="Country" name="Country">
                                            <option value="Korea, Democratic Republic of (North Korea)">	Korea, Democratic Republic of (North Korea) 	</option>

                                        </select>
                                        {/* <div className="form-control-feedback">
                                            <i className="icon-lock2 text-muted"></i>
                                        </div> */}
                                    </div>
                                    <div className="form-group">
                                        <button type="button" onClick={this.getPassword} className="btn btn-primary btn-block">Submit <i className="icon-circle-right2 ml-2"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default  withRouter(ForgotPassword);